import styled from 'styled-components';
import {
  mediaBreakpointUp,
  mediaBreakpointDown,
} from '../../../../styles/grid';

const modalMobileBreakpoint = mediaBreakpointDown.sm;
const modalDesktopBreakpoint = mediaBreakpointUp.md;

export const BodyContainer = styled.div`
  ${modalMobileBreakpoint} {
    padding: 15px 8px;
  }

  ${modalDesktopBreakpoint} {
    padding: 20px;
  }
`;
